import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var changePswRes;
export const changePswTodo = createAsyncThunk('changePsw', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url:  process.env.REACT_APP_API_URL + `password_update/${data?.id}`,
            data: {
                "password": data.new_psw,
                "confpassword":  data.confirm_psw    
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })
        return changePswRes = res.data

    } catch (error) {
        return changePswRes = error.response.data
    }
})


